export const ATTR_COLOR = "color";
export const ATTR_BGCOLOR = "bgcolor";
export const DATA_OG_STYLE_COLOR = "data-ogsc";
export const DATA_OG_ATTR_COLOR = "data-ogac";
export const DATA_OG_STYLE_BACKGROUNDCOLOR = "data-ogsb";
export const DATA_OG_ATTR_BGCOLOR = "data-ogab";
export const DATA_OG_STYLE_BORDER_TOP_COLOR = "data-ogsbtc";
export const DATA_OG_STYLE_BORDER_RIGHT_COLOR = "data-ogsbrc";
export const DATA_OG_STYLE_BORDER_BOTTOM_COLOR = "data-ogsbbc";
export const DATA_OG_STYLE_BORDER_LEFT_COLOR = "data-ogsblc";
